// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Loading Screen - Hidden, using opacity approach in HTML instead */
#loading-screen {
  display: none;
}

/* General Styles */
body {
  font-family: 'Inter', sans-serif;
  background-color: #161b22;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  margin: 0;
  padding: 20px;
  overflow-x: hidden; /* Prevent horizontal scrolling from keys */
  overflow-y: auto; /* Allow vertical scrolling if needed */
}

#app-container {
  /* Constrain by viewport width, available height, and max size */
  width: min(90vw, calc(100vh - 300px), 600px);
  margin-top: auto;
  margin-bottom: auto;
}

/* Game Title Styling - Warped Effect */
.game-title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
  box-sizing: border-box;
  padding: 0 2px;
  min-height: 50px; /* Reserve space for title to prevent layout shift */
  font-size: clamp(0.5rem, 2vw, 1rem); /* Scale title with viewport */
}

.title-char {
  font-weight: 900;
  color: #00ff80;
  text-shadow: 0 0 5px #ff4d4f, 0 0 10px rgba(255, 77, 79, 0.7);
  text-transform: uppercase;
  line-height: 1;
  user-select: none;
}

/* Score Panel */
.score-panel-top {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 5px 10px 5px;
  color: #c9d1d9;
  font-size: clamp(0.9rem, 3vw, 1.2rem);
  font-weight: 700;
  text-shadow: 0 0 5px #ff7875, 0 0 10px rgba(255, 77, 79, 0.5);
}

/* Phaser Container */
#phaser-game-container {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1; /* Maintain square shape */
}

#phaser-game {
  width: 100%;
  height: 100%;
  box-shadow: 0 10px 30px rgba(0, 255, 128, 0.4);
  border: 4px solid #00ff80;
  border-radius: 12px;
  background-color: #161b22;
  overflow: hidden;
}

#phaser-game canvas {
  width: 100% !important;
  height: 100% !important;
}

/* Touch Controls for Mobile */
.touch-controls {
  display: none; /* Hidden on desktop, shown on mobile */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* Allow clicks through to game */
}

.touch-region {
  position: absolute;
  pointer-events: auto;
  cursor: pointer;
  /* Visual feedback on touch (optional, can be removed) */
  transition: background-color 0.1s;
}

.touch-region:active {
  background-color: rgba(0, 255, 128, 0.1);
}

.touch-up {
  top: 0;
  left: 0;
  right: 0;
  height: 30%;
}

.touch-down {
  bottom: 0;
  left: 0;
  right: 0;
  height: 30%;
}

.touch-left {
  left: 0;
  top: 30%;
  bottom: 30%;
  width: 30%;
}

.touch-right {
  right: 0;
  top: 30%;
  bottom: 30%;
  width: 30%;
}

/* Button Container - Fixed height to prevent layout shift */
.button-container {
  min-height: 120px; /* Enough for game over message + button */
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

/* Buttons */
.start-button {
  background-color: #238636;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 700;
  transition: background-color 0.2s, transform 0.1s, box-shadow 0.2s, opacity 0.2s;
  box-shadow: 0 4px #1c6b29;
  user-select: none;
  cursor: pointer;
  text-align: center;
  width: 100%;
  border: none;
  outline: none;
}

.start-button:active {
  background-color: #1c6b29;
  transform: translateY(2px);
  box-shadow: 0 2px #1c6b29;
}

.start-button.hidden {
  visibility: hidden;
  opacity: 0;
}

/* Game Over Message */
.game-over-message {
  color: #ff4d4f;
  font-size: 1.5rem;
  font-weight: 900;
  text-shadow: 0 0 10px rgba(255, 77, 79, 0.8);
  margin-bottom: 10px;
  text-align: center;
}

/* D-Pad (Mobile) */
.dpad-container {
  display: none;
  grid-template-areas: '. up .' 'left center right' '. down .';
  gap: 5px;
  width: 200px;
  margin: 30px auto 20px auto; /* Centered horizontally with more top spacing */
}

.control-button {
  background-color: #238636;
  color: white;
  border-radius: 8px;
  padding: 15px 15px;
  font-size: 1.5rem;
  line-height: 1;
  box-shadow: 0 4px #1c6b29;
  transition: background-color 0.2s, transform 0.1s, box-shadow 0.2s;
}
.control-button:active {
  background-color: #1c6b29;
  transform: translateY(2px);
  box-shadow: 0 2px #1c6b29;
}

.up {
  grid-area: up;
}
.down {
  grid-area: down;
}
.left {
  grid-area: left;
}
.right {
  grid-area: right;
}

/* Modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.modal-content {
  background-color: #161b22;
  color: #c9d1d9;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 255, 128, 0.6);
  text-align: center;
  border: 2px solid #00ff80;
}
.hidden {
  display: none;
}

/* Enable touch controls on all touch devices (phones, tablets, iPads) */
@media (pointer: coarse) {
  .touch-controls {
    display: block;
  }
}

/* Optimize layout for smaller screens */
@media (max-width: 768px) {
  body {
    padding: 10px; /* Reduce padding on smaller screens for more space */
  }
}

/* Larger screens can keep more padding */
@media (min-width: 769px) {
  body {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,kBAAkB,EAAE,2CAA2C;EAC/D,gBAAgB,EAAE,uCAAuC;AAC3D;;AAEA;EACE,gEAAgE;EAChE,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,gBAAgB,EAAE,oDAAoD;EACtE,mCAAmC,EAAE,8BAA8B;AACrE;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;EACvB,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,aAAa,EAAE,uCAAuC;EACtD,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB,EAAE,iCAAiC;AACzD;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,wDAAwD;EACxD,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;;AAEA,4DAA4D;AAC5D;EACE,iBAAiB,EAAE,0CAA0C;EAC7D,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gFAAgF;EAChF,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR,YAAY;EACZ,2BAA2B,EAAE,gDAAgD;AAC/E;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kEAAkE;AACpE;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA,wEAAwE;AACxE;EACE;IACE,cAAc;EAChB;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,aAAa,EAAE,qDAAqD;EACtE;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Loading Screen - Hidden, using opacity approach in HTML instead */\n#loading-screen {\n  display: none;\n}\n\n/* General Styles */\nbody {\n  font-family: 'Inter', sans-serif;\n  background-color: #161b22;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 100vh;\n  margin: 0;\n  padding: 20px;\n  overflow-x: hidden; /* Prevent horizontal scrolling from keys */\n  overflow-y: auto; /* Allow vertical scrolling if needed */\n}\n\n#app-container {\n  /* Constrain by viewport width, available height, and max size */\n  width: min(90vw, calc(100vh - 300px), 600px);\n  margin-top: auto;\n  margin-bottom: auto;\n}\n\n/* Game Title Styling - Warped Effect */\n.game-title-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 24px;\n  box-sizing: border-box;\n  padding: 0 2px;\n  min-height: 50px; /* Reserve space for title to prevent layout shift */\n  font-size: clamp(0.5rem, 2vw, 1rem); /* Scale title with viewport */\n}\n\n.title-char {\n  font-weight: 900;\n  color: #00ff80;\n  text-shadow: 0 0 5px #ff4d4f, 0 0 10px rgba(255, 77, 79, 0.7);\n  text-transform: uppercase;\n  line-height: 1;\n  user-select: none;\n}\n\n/* Score Panel */\n.score-panel-top {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0 5px 10px 5px;\n  color: #c9d1d9;\n  font-size: clamp(0.9rem, 3vw, 1.2rem);\n  font-weight: 700;\n  text-shadow: 0 0 5px #ff7875, 0 0 10px rgba(255, 77, 79, 0.5);\n}\n\n/* Phaser Container */\n#phaser-game-container {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1 / 1; /* Maintain square shape */\n}\n\n#phaser-game {\n  width: 100%;\n  height: 100%;\n  box-shadow: 0 10px 30px rgba(0, 255, 128, 0.4);\n  border: 4px solid #00ff80;\n  border-radius: 12px;\n  background-color: #161b22;\n  overflow: hidden;\n}\n\n#phaser-game canvas {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n/* Touch Controls for Mobile */\n.touch-controls {\n  display: none; /* Hidden on desktop, shown on mobile */\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none; /* Allow clicks through to game */\n}\n\n.touch-region {\n  position: absolute;\n  pointer-events: auto;\n  cursor: pointer;\n  /* Visual feedback on touch (optional, can be removed) */\n  transition: background-color 0.1s;\n}\n\n.touch-region:active {\n  background-color: rgba(0, 255, 128, 0.1);\n}\n\n.touch-up {\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 30%;\n}\n\n.touch-down {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 30%;\n}\n\n.touch-left {\n  left: 0;\n  top: 30%;\n  bottom: 30%;\n  width: 30%;\n}\n\n.touch-right {\n  right: 0;\n  top: 30%;\n  bottom: 30%;\n  width: 30%;\n}\n\n/* Button Container - Fixed height to prevent layout shift */\n.button-container {\n  min-height: 120px; /* Enough for game over message + button */\n  margin-top: 20px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n/* Buttons */\n.start-button {\n  background-color: #238636;\n  color: white;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-weight: 700;\n  transition: background-color 0.2s, transform 0.1s, box-shadow 0.2s, opacity 0.2s;\n  box-shadow: 0 4px #1c6b29;\n  user-select: none;\n  cursor: pointer;\n  text-align: center;\n  width: 100%;\n  border: none;\n  outline: none;\n}\n\n.start-button:active {\n  background-color: #1c6b29;\n  transform: translateY(2px);\n  box-shadow: 0 2px #1c6b29;\n}\n\n.start-button.hidden {\n  visibility: hidden;\n  opacity: 0;\n}\n\n/* Game Over Message */\n.game-over-message {\n  color: #ff4d4f;\n  font-size: 1.5rem;\n  font-weight: 900;\n  text-shadow: 0 0 10px rgba(255, 77, 79, 0.8);\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n/* D-Pad (Mobile) */\n.dpad-container {\n  display: none;\n  grid-template-areas: '. up .' 'left center right' '. down .';\n  gap: 5px;\n  width: 200px;\n  margin: 30px auto 20px auto; /* Centered horizontally with more top spacing */\n}\n\n.control-button {\n  background-color: #238636;\n  color: white;\n  border-radius: 8px;\n  padding: 15px 15px;\n  font-size: 1.5rem;\n  line-height: 1;\n  box-shadow: 0 4px #1c6b29;\n  transition: background-color 0.2s, transform 0.1s, box-shadow 0.2s;\n}\n.control-button:active {\n  background-color: #1c6b29;\n  transform: translateY(2px);\n  box-shadow: 0 2px #1c6b29;\n}\n\n.up {\n  grid-area: up;\n}\n.down {\n  grid-area: down;\n}\n.left {\n  grid-area: left;\n}\n.right {\n  grid-area: right;\n}\n\n/* Modal */\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.85);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 100;\n}\n\n.modal-content {\n  background-color: #161b22;\n  color: #c9d1d9;\n  padding: 30px;\n  border-radius: 12px;\n  box-shadow: 0 0 20px rgba(0, 255, 128, 0.6);\n  text-align: center;\n  border: 2px solid #00ff80;\n}\n.hidden {\n  display: none;\n}\n\n/* Enable touch controls on all touch devices (phones, tablets, iPads) */\n@media (pointer: coarse) {\n  .touch-controls {\n    display: block;\n  }\n}\n\n/* Optimize layout for smaller screens */\n@media (max-width: 768px) {\n  body {\n    padding: 10px; /* Reduce padding on smaller screens for more space */\n  }\n}\n\n/* Larger screens can keep more padding */\n@media (min-width: 769px) {\n  body {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
